import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import MainView from '../../../../components/MainView';
import NavHistory from '../../../../components/NavHistory';
import accessServices from '../../../../services/accessServices';
import FormAccess from '../FormAccess';

import './styles.css';



export default function EditAccessPage(props) {
    const [access, setAccess] = useState({});
    const {id} = useParams();

    async function getAccess() {
        try {
            const response = await accessServices.getAccessInfos(id);
            setAccess(response.data);
        } catch(err) {
            alert("Erro ao pegar informações do acesso.");
        }
    } 

    async function editAccess(accessInfo) {
        try {
            if(accessInfo.nome && accessInfo.tipo !== "" && accessInfo.email && accessInfo.telefone && accessInfo.ddi && accessInfo.iso2_ddi){
                await accessServices.patchAccess(access.id,accessInfo.nome, accessInfo.telefone, accessInfo.ddi, accessInfo.iso2_ddi, accessInfo.email, accessInfo.password,accessInfo.foto);
                props.history.goBack();
            }
            else {
                alert("Todos os campos com asterisco devem ser preenchidos.");
            }

        } catch(err) {
            console.log(err.message);
            alert("Não foi possível editar o acesso. Verifique se todas as informações estão corretas.");
        }
    }

    useEffect(() => {
        getAccess();
    }, [])
    return (
        <MainView
            adminMenu
            currentPage='accesses'
        >
            <NavHistory
            navPages={['Acessos', (access.nome ? access.nome : ""),'Editar']}
            />
            <FormAccess
            title="Edição de Acesso"
            buttonTitle="Salvar alterações"
            onClick={editAccess}
            edit
            access={access}
            />
        </MainView>
    )
}